import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

delete Icon.Default.prototype._getIconUrl

const iconMap = new Icon({
  iconSize: [20, 30],
  // iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  // iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconRetinaUrl: require('../../img/marker-icon-2x-green.png'),
  iconUrl: require('../../img/marker-icon-green.png'),
  shadowUrl: require('../../img/marker-shadow.png'),
  shadowSize: [20, 20],
  shadowAnchor: [10, 10]
})

export default iconMap
